import * as React from "react";

/* ──────────────────────────────────────────────────────────────────────────
 * NKEyebrow — small uppercase mono label used above section headlines.
 *
 * Editorial-magazine register. Sits above an H1 or H2 to give the reader
 * a quick "what section is this" signal. Mono + tracking + uppercase.
 *
 * Extracted in Slice 14 from three duplicate local definitions.
 * ────────────────────────────────────────────────────────────────────────── */

export interface NKEyebrowProps {
  children: React.ReactNode;
  className?: string;
}

export function NKEyebrow({ children, className }: NKEyebrowProps) {
  return (
    <p
      className={
        "font-mono text-xs font-medium tracking-[0.25em] text-zinc-900 uppercase" +
        (className ? ` ${className}` : "")
      }
    >
      {children}
    </p>
  );
}
